<div class="modal-content">
    <div class="modal-header">
      <div class="modal-header-left d-flex">
        <button type="button" class="close mx-1" [ngClass]="isForwardActive ? 'disabled-button':''" (click)="performEmailOperation('Resend')" title="Resend">
            <i class="icon-forward"></i>
        </button>
        <button type="button" class="close mx-1" [ngClass]="isResendActive ? 'disabled-button':''" (click)="performEmailOperation('Forward')" title="Forward">
            <i class="fluent-ArrowForward"></i>
        </button>
        <button type="button" class="close mx-1" [ngClass]="isForwardActive || isResendActive ? 'disabled-button':''" (click)="performEmailOperation('Print')" title="Print">
            <i class="icon-print"></i>
        </button>
        <button type="button" class="close mx-1 mt-2" [ngClass]="isForwardActive || isResendActive ? 'disabled-button':''" (click)="performEmailOperation('Export')" title="Export">
            <i class="fluent-ArrowDownload"></i>
        </button>
      </div>
      <div class="modal-header-right">
        <button type="button" class="close" (click)="close()">
          <i class="icon-close"></i>
        </button>
      </div>
    </div>
    <div class="modal-body" #printableModalContent>
      <div class="modal-body-inner">
        <form [formGroup]="form">
          <div class="row">
            <div class="col">
              <app-input
                [form]="form"
                controlName="ToAddress"
                label="To"
                [disabled]="true"
              ></app-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <app-input
                [form]="form"
                controlName="Subject"
                label="Subject"
                [disabled]="true"
              ></app-input>
            </div>
          </div>
          <div class="row" *ngIf="form?.value?.Message">
            <div class="col">
                <h3 class="mb-2">Message</h3>
                <div [innerHTML]="form.value.Message | safeHTML" class="mail-message-container" style="font-size:14px;"></div>
            </div>
          </div>
          <div class="row mt-4" *ngIf="isForwardActive">
            <div class="col">
              <app-textarea
                [form]="form"
                controlName="ForwardTo"
                label="Forward To"
                infoText="Enter multiple email addresses separated by semicolons (;)"
                [IsFromForm]="true"
                [DisplayOnScreen]="true"
              ></app-textarea>
            </div>
          </div>
          <div class="row mt-2" *ngIf="isResendActive || isForwardActive">
            <div class="col">
              <app-textarea
                [form]="form"
                controlName="Comments"
                label="Comment to Include in Email"
              ></app-textarea>
            </div>
          </div>
        </form>
      </div>
    </div>
  
    <div class="modal-footer">
      <div class="modal-footer-bottom">
        <app-modal-action-btns
          [form]="form"
          (onReject)="(isResendActive || isForwardActive) ? cancelEmailOperation() : close()"
          (onConfirm)="submit()"
          [rejectTitle]="(isResendActive || isForwardActive) ? 'Cancel':'Close'"
          [showSave]="isResendActive || isForwardActive"
          [confirmTitle]="isResendActive ? 'Resend':'Forward'"
          [useFormSubmit]="false"
        ></app-modal-action-btns>
      </div>
    </div>
  </div>
  